import React from "react";
import "./MovePaperWorkCard.scss"
import { CardLayout } from "components/cardLayout";
import { PageHeading } from "components/pageHeading";
import { SubHeading } from "components/subHeading";
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'

export interface MovePaperWorkCardProps {
    //custDetails?:any;
}

export interface MovePaperWorkCardState {
    Customer: any;
    EstimatorDetails: any
}

//const custDetails=JSON.parse(localStorage.getItem("customerDetails") || "{}");

class MovePaperWorkCard extends React.Component<MovePaperWorkCardProps, MovePaperWorkCardState> {
    private _isMounted: boolean = false;
    constructor(props: MovePaperWorkCardProps) {
        super(props);
        this.state = {
            Customer: [],
            EstimatorDetails: []
        };
    }

    async fetchData() {
        const params = new URLSearchParams(window.location.search);
        var CID = params.get('customerid');
        var securetoken = params.get('customerToken');
        if (!CID) {
            CID = localStorage.getItem("CID")
        }
        else {
            localStorage.setItem("CID", CID)
        }
        if (!securetoken) {
            securetoken = localStorage.getItem("securetoken")
        }
        else {
            localStorage.setItem("securetoken", securetoken)
        }
        let response = await getCustomerDetails(CID || "", securetoken || "")
        this.setState({ Customer: response[0] })
        localStorage.setItem("customerDetails", JSON.stringify(response[0]));
        console.log("CustomerDetail:" + JSON.stringify(this.state.Customer));
        var estDetails = JSON.parse(localStorage.getItem("EstimatorDetails") || "")
        this.setState({ EstimatorDetails: estDetails })
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();

    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CardLayout style={{ alignItems: "start" }}>
                <div className="movecustomer-detail">
                    <b>Customer Details</b>
                </div>
                <div className="movecustomer-detail">
                    <h1>AMS Job Identifier (CID):</h1>
                    <h1><span>{this.state.Customer.customerID}</span></h1>
                </div>
                <div className="movecustomer-detail">
                    <h1>Customer Name:</h1>
                    <h3><span>{this.state.Customer.customerName}</span></h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Origin:</h1>
                    <h3><span>{this.state.Customer.customerAdd1}, {this.state.Customer.customerAdd2}</span></h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Contact:</h1>

                    <h3><span>{this.state.Customer.customerPh}</span></h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Email:</h1>
                    <h3><span>{this.state.EstimatorDetails.email}</span></h3>
                </div>


                <div className="movecustomer-detail">
                    <h1>Delivery Contact: <br /> <span>Consignee</span></h1>
                    <h3><span>{this.state.Customer.customerName}</span></h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Destination:</h1>
                    <h3><span>{this.state.Customer.customerDestAdd1}, {this.state.Customer.customerDestAdd2}</span></h3>
                </div>
                <div className="movecustomer-detail">
                    <h1>Contact:</h1>
                    <h3><span>{this.state.Customer.customerDestPh}</span></h3>
                </div>

            </CardLayout>
        );
    }
}

export default MovePaperWorkCard;